import { capitalizeSentence } from './capitalizeSentence'
import { filterEmptyStrings } from './filterEmptyStrings'

export const formatTitle = (title: string) => {
  return capitalizeSentence(filterEmptyStrings(title || ''))
}
